import { ValueOf } from '../interfaces';

export const URL_PARAMETER = {
    KEYWORD: 'kw',
    ERR_TYPE: 'err_type',
    ERR_CODE: 'err_code',
    EXT: 'ext', // 表单外链扩展
    REDIRECT_URI: 'redirect_uri', // 跳转链接
    REFERER_URI: 'referer_uri', // 来源链接
    FILETYPE: 'fileType',
    DOWNLOAD_URL: 'downloadUrl',
    POSITION: 'position',
    NAME: 'name',
    EMAIL: 'email', // 邮件
    PHONE: 'phone', // 手机
    CORP_NAME: 'corp_name', // 企业名称
    NICKNAME: 'nickname', // 昵称
    IS_MOBILE: '_mobile', // 是否移动端
    HIDE_HEADER: '__hideHeader', // 隐藏导航头
    WX_PLATFORM: 'is_wx_platform', // 微信平台
    NEED_VALIDATE: 'needValidate', // 验证码校验
    UTM_SRC: 'utm_src', // 流量来源
    TRACK_UUID: 'track_uuid', // 跨域串联设备标识
    TRACK_UTMS: 'track_utms', // 跨域串联 UTM 参数
    TRACK_UTM_SRC: 'track_utm_src', // 跨域串联 UTM 来源
    TRACK_UTM_ID: 'track_utm_id', // 跨域串联 UTM 标识
    TENANT_VERIFY_TYPE: 'type', // 认证类型
    INVITED_BY: 'invited_by', // 企业邀请来源对象
    INVITATION_TOKEN: 'invitation_token', // 企业邀请token
    MEMBER_TYPE: 'member_type', // 邀请成员类型
    DEPT_NO: 'dept_no', // 企业公开邀请链接中指定的部门编号
    DEPT_ID: 'dept_id',
    ROLE_ID: 'role_id',
    TOKEN: 'token', // 互联组织私有邀请链接中的token
    IS_PUBLIC: 'is_public', // 是否为公共邀请
    EMBED: 'embed', // 外链iframe
    KEY: 'key', // key
    TAB_KEY: 'tabKey',
    REF_GROUP_ID: 'refGroupId',
    // 订单类型
    ORDER_TYPE: 'type',
    PLUGIN_ID: 'pluginId',
    DATA_SOURCE_ID: 'dataSourceId',
    CONTENT_ID: 'content_id',
    DAYS: 'days',
    DATA_SOURCE_TABLE: 'dataSourceTableId',
    /** 数据源同步云币弹窗，值为 18021 / 18022 / low */
    DATA_SOURCE_COIN_ALERT: 'data_source_coin_alert',
    /** 数据源同步云币弹窗关联的同步表 */
    DATA_SOURCE_COIN_TABLES: 'data_source_coin_tables',
    /** 数据源同步云币弹窗关联的同步起点 */
    DATA_SOURCE_COIN_SYNC_BEGIN: 'data_source_coin_sync_begin',
    PLUGIN_ID_SNAKE: 'plugin_id',
    HOST_CORP_ID: 'host_corp_id', // 主体企业corpid
    RESET_STATUS: 'reset_status', // 进入重置密码页面时的状态
    IS_CONFIRM: 'isConfirm',
    TENANT_VERIFY_TOKEN: 'tenant_verify_token',
    TENANT_ID: 'tenant_id',
    TEMPLATE_FILE_NAME: 'template_file_name',
    LOCALE: 'locale',
    CORP_ID: 'corp_id',
    SUITE_ID: 'suite_id',
    SUITE_METADATA: 'suite_metadata',
    // 通过钉钉内置浏览器打开页面
    DD_TAB: 'ddtab',
    _FROM: '_from',
    TARGET: 'target',
    ORDER_ID: 'order_id',
    ATTNAME: 'attname',
    WITH_CREDENTIALS: '_wj_credentials',
    ODM_ID: 'odm_id',
    /** 插件市场嵌入来源 */
    PLUGIN_STORE_SOURCE: 'plugin_store_source',
    // 跳转通讯录后直接打开邀请成员弹窗
    INVITE_MEMBER: 'invite_member',
    // 路径引导打开通讯录后高亮「邀请成员」按钮
    PATH_GUIDE_INVITE: 'path_guide_invite',
    // 跳转知识库后打开 AI 问答配置
    KMS_QA_ACTION: 'qa_action'
} as const;

export type QueryKey = ValueOf<typeof URL_PARAMETER>;
